import { Message } from "aderant-conflicts-models";

export const QueueMessages = {
    VLD_MESSAGE_TOO_BIG: new Message<[id: string, queueName: string, messageSize: number]>(
        "VLD_MESSAGE_TOO_BIG",
        "Message with id {0} is too big to put on queue {1}. Message is {2} bytes. Max size is 64kb."
    )
};
